__turbopack_context__.v({
  "card": "ImageOptionCard-module__18Cv1q__card",
  "grid": "ImageOptionCard-module__18Cv1q__grid",
  "image-wrap": "ImageOptionCard-module__18Cv1q__image-wrap",
  "price": "ImageOptionCard-module__18Cv1q__price",
  "sub": "ImageOptionCard-module__18Cv1q__sub",
  "tag": "ImageOptionCard-module__18Cv1q__tag",
  "title": "ImageOptionCard-module__18Cv1q__title",
});
